export default __webpack_public_path__ + "img/28e5756ff33f892db9b81bb0740aa58f.svg";